export default "__VITE_ASSET__843fa8f3__"